import { render, staticRenderFns } from "./popBox.vue?vue&type=template&id=3fe53d36&scoped=true&"
import script from "./popBox.vue?vue&type=script&lang=js&"
export * from "./popBox.vue?vue&type=script&lang=js&"
import style0 from "./popBox.vue?vue&type=style&index=0&id=3fe53d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe53d36",
  null
  
)

export default component.exports